// class for adding new record via ajax
export class Add {
    constructor(){
        this.button = $('.default-add-button');
        this.form = $('#default-form');
        this.modal = $('#mdl-default-form');

        this.form.addClass('add-form').removeClass('edit-form');
        this.modal.find('.modal-title').text(this.button.data('title'));
        this.modal.modal('show');
    }
    submit(){
        let self = this;
        $.ajax({
            type:'post',
            url: `/${this.button.data('action')}`,
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data:this.form.serialize(),
            success:function(data){
                $('.item-row:first').clone().appendTo('.items-container');
                let currentRow = $('.items-container').children().last();
                currentRow.removeClass('d-none');
                currentRow.attr("tabindex",-1);
                let fieldItem = currentRow.find('.item-field');
                $.each(fieldItem, function(i, v){
                    $(this).html(data['record'][$(this).data('name')]);
                    if($(this).is('a')){
                        $(this).attr("href", $(this).attr('href') + data['record']['id']);
                    };
                });
                self.modal.modal('hide');
                $('.row-count').text(data['total']);
            },
            error:function(data){
                console.log('error');
            }
        });
    }
}
export class Edit{
    constructor(button){
        this.button = button;
        this.currentRow = this.button.closest('.item-row');
        this.form = $('#default-form');
        this.modal = $('#mdl-default-form');

        let self = this;
        this.form.addClass('edit-form');
        this.form.removeClass('add-form');
        this.modal.find('.modal-title').text(this.button.data('title'));
        let inputs = this.modal.find('input');
        let selects = this.modal.find('select');
        $.each(inputs, function() {
            let field = self.currentRow.find('.' + $(this).attr('name'));
            let val = field.text();
            if(field.hasClass('date')){
                val = self.formatDate(val);
            }
            $(this).val(val);
        });
        $.each(selects, function(){
            var val = self.currentRow.find('.' + $(this).attr('name')).text();
            $(this).val(val).change();
        });
        this.modal.modal('show');
    }

    submit(){
        let self = this;
        $.ajax({
            type:'post',
            url: `/${this.button.data('action')}`,
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data:this.form.serialize(),
            success:function(data){
                var fieldItem = self.currentRow.find('.item-field');
                $.each(fieldItem, function(i, v){
                    $(this).html(data[$(this).data('name')]);
                });
                self.modal.modal('hide');
            },
            error:function(data){
                alert('Error: Please contact the administrator');
                self.modal.modal('hide');
            }
        });
    }

    formatDate(date){
        if(date != ''){
            date = new Date(date);
            var d = date.getDate();
            var m =  date.getMonth();
            m += 1;  // JavaScript months are 0-11
            var y = date.getFullYear();
            return m + '/' + d + '/' + y;
        }
        else{
            return '';
        }
    }
}


export class Delete{
    constructor(button){
        this.button = button;
        this.currentRow = this.button.closest('.item-row');
        this.id = this.currentRow.find('.id').text();
        this.action = this.button.data('action');

        $('#mdlPrompt').on('shown.bs.modal', function () {
            $('.confirm-delete').trigger('focus')
        })
        let html = ''
                + '<p>Are you sure you want to delete this item</p>'
                + '<a href="#" class="btn btn-sm btn-light border confirm-delete" data-dismiss="modal" data-action="' + this.action + '"><i class="fas fa-check text-primary"></i> Yes</a>'
        $('#mdlPrompt .modal-body').html(html);
        $('#mdlPrompt').modal('show');
    }
    confirm(){
        let self = this;
        $.ajax({
            type:'post',
            url: `/${self.action}`,
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data:{
                'id' : self.id
            },
            success:function(data){
                self.currentRow.fadeOut(300, function(){
                    $(this).remove();
                });
                $('.row-count').text(data);
            },
            error:function(data){
                alert('Error, please contact Admin');
            }
        });
    }
}
